// @flow
import { generateSchema } from "src/utils/schemaUtils";
import { recordInput } from "src/models/TrendModel";
export default generateSchema([], {
  recordInput
});
